import { createStyles, makeStyles } from '@material-ui/core'

export const useHelpFindProjectStyles = makeStyles((theme) =>
  createStyles({
    openModalButton: {
      padding: 0,
      fontSize: '0.875rem',
      fontFamily: 'Montserrat',
      whiteSpace: 'nowrap',
      textTransform: 'none',
      transition: '0.3s',
      fontWeight: 500,
      cursor: 'pointer',
      '&:hover': {
        textDecoration: 'underline'
      },
      [theme.breakpoints.down(1441)]: {
        lineHeight: '17px'
      },
      [theme.breakpoints.down(1280)]: {
        maxWidth: '100%'
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: '0.75rem'
      }
    }
  })
)
